import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps } from "vue"

import SelectionCard from '@/components/neue/wizard/SelectionCard.vue'
import SelectionGroup from '@/components/neue/wizard/SelectionGroup.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import { RHYTHMS, sectionCopy } from '@/config/dropWizardSteps'


export default {
  __name: 'StepOften',
  setup(__props) {

const wizard = injectWizard()

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(WizardSection, _mergeProps(_unref(sectionCopy)('rhythm', _unref(wizard).data), { plain: "" }), {
    default: _withCtx(() => [
      _createVNode(SelectionGroup, { label: "How often" }, {
        default: _withCtx(({ groupName }) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(RHYTHMS), (option) => {
            return (_openBlock(), _createBlock(SelectionCard, {
              key: option.value,
              name: groupName,
              icon: "repeat",
              title: option.title,
              subtitle: option.subtitle,
              selected: _unref(wizard).data.rhythm === option.value,
              onSelect: $event => (_unref(wizard).data.rhythm = option.value)
            }, null, 8, ["name", "title", "subtitle", "selected", "onSelect"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16))
}
}

}